import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShieldHalved,
  faCodeMerge,
  faServer,
  faMagnifyingGlass,
  faDatabase,
  faCode,
  faWrench,
} from "@fortawesome/free-solid-svg-icons";
import { skillsGrouped, securityToolbox } from "../data/portfolioData";

export default function Tech() {
  const getCategoryIcon = (category) => {
    switch (category) {
      case "Security Operations":
        return faShieldHalved;
      case "Application Security":
        return faCodeMerge;
      case "Infrastructure Security":
        return faServer;
      case "Security Research":
        return faMagnifyingGlass;
      case "Data & Infrastructure":
        return faDatabase;
      case "Software Engineering & R&D":
        return faCode;
      default:
        return faWrench;
    }
  };

  return (
    <section id="skills" className="cyber-section">
      <div className="container">
        {/* Header */}
        <div className="mb-5">
          <div className="section-label">TECHNICAL COMPETENCIES</div>
          <h2 className="section-title">Grouped Skills &amp; Security Capabilities</h2>
          <p className="section-subtitle">
            Core specializations organized by operational domain, verified through hands-on
            implementation, penetration assessments, and system administration.
          </p>
        </div>

        {/* 1. Grouped Skills Cards */}
        <div className="row g-4 mb-5">
          {skillsGrouped.map((group, idx) => (
            <div key={idx} className="col-lg-4 col-md-6">
              <div
                className="cyber-card h-100 p-4"
                style={{
                  background: "var(--bg-surface)",
                  borderColor: "var(--border-subtle)",
                }}
              >
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div
                    style={{
                      width: 38,
                      height: 38,
                      borderRadius: "8px",
                      background: `${group.accent}15`,
                      border: `1px solid ${group.accent}30`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: group.accent,
                    }}
                  >
                    <FontAwesomeIcon icon={getCategoryIcon(group.category)} />
                  </div>
                  <h3 style={{ fontSize: "1.1rem", fontWeight: 700, margin: 0, color: "var(--text-primary)" }}>
                    {group.category}
                  </h3>
                </div>

                <div className="d-flex flex-wrap gap-2 pt-2">
                  {group.skills.map((skill, sIdx) => (
                    <span
                      key={sIdx}
                      className="cyber-tag font-mono"
                      style={{
                        padding: "6px 12px",
                        fontSize: "0.82rem",
                        background: "var(--bg-surface-elevated)",
                        border: "1px solid var(--border-subtle)",
                        color: "var(--text-primary)",
                      }}
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 2. Compact Security Toolbox */}
        <div className="pt-3">
          <div className="d-flex align-items-center gap-2 mb-4">
            <FontAwesomeIcon icon={faWrench} style={{ color: "var(--accent)" }} />
            <h3 style={{ fontSize: "1.4rem", fontWeight: 700, margin: 0 }}>
              Defensive &amp; Investigative Toolbox
            </h3>
          </div>

          <div className="row g-3">
            {securityToolbox.map((tool, idx) => (
              <div key={idx} className="col-6 col-md-4 col-lg-3">
                <div
                  className="cyber-card-elevated p-3 h-100 d-flex flex-column justify-content-between"
                  style={{
                    background: "var(--bg-surface)",
                    border: "1px solid var(--border-subtle)",
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="font-mono text-muted" style={{ fontSize: "0.68rem" }}>
                      {tool.badge}
                    </span>
                    <span
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor: "var(--accent)",
                        opacity: 0.6,
                      }}
                    />
                  </div>

                  <div>
                    <div style={{ fontWeight: 600, fontSize: "0.95rem", color: "var(--text-primary)" }}>
                      {tool.name}
                    </div>
                    <div style={{ fontSize: "0.78rem", color: "var(--text-secondary)", marginTop: "2px" }}>
                      {tool.role}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
